// Ghana Regions and Major Cities Data
export const ghanaLocations = {
  "Greater Accra": [
    "Accra",
    "Tema",
    "Madina",
    "Teshie",
    "Nungua",
    "Kasoa",
    "Dome",
    "Adenta",
    "Ashiaman",
    "Spintex",
    "Dansoman",
    "Lapaz",
    "Achimota",
  ],
  "Ashanti": [
    "Kumasi",
    "Obuasi",
    "Konongo",
    "Mampong",
    "Ejisu",
    "Bekwai",
    "Tepa",
    "Agona",
    "Juaso",
    "Effiduase",
  ],
  "Western": [
    "Sekondi-Takoradi",
    "Tarkwa",
    "Axim",
    "Prestea",
    "Shama",
    "Takoradi",
    "Sekondi",
    "Agona Nkwanta",
  ],
  "Eastern": [
    "Koforidua",
    "Akosombo",
    "Nkawkaw",
    "Mpraeso",
    "Kibi",
    "Akropong",
    "Suhum",
    "Akim Oda",
    "Somanya",
  ],
  "Central": [
    "Cape Coast",
    "Winneba",
    "Kasoa",
    "Swedru",
    "Mumford",
    "Saltpond",
    "Anomabo",
    "Apam",
  ],
  "Northern": [
    "Tamale",
    "Yendi",
    "Salaga",
    "Savelugu",
    "Kumbungu",
    "Tolon",
    "Gushegu",
  ],
  "Upper East": [
    "Bolgatanga",
    "Navrongo",
    "Bawku",
    "Paga",
    "Zebilla",
  ],
  "Upper West": [
    "Wa",
    "Lawra",
    "Jirapa",
    "Tumu",
    "Nadowli",
  ],
  "Volta": [
    "Ho",
    "Keta",
    "Aflao",
    "Hohoe",
    "Kpando",
    "Sogakope",
    "Dzodze",
  ],
  "Bono": [
    "Sunyani",
    "Berekum",
    "Dormaa Ahenkro",
    "Wenchi",
    "Techiman",
  ],
  "Bono East": [
    "Techiman",
    "Atebubu",
    "Kintampo",
    "Yeji",
    "Nkoranza",
  ],
  "Ahafo": [
    "Goaso",
    "Bechem",
    "Hwidiem",
    "Kukuom",
    "Acherensua",
  ],
  "Savannah": [
    "Damongo",
    "Bole",
    "Salaga",
    "Sawla",
    "Buipe",
  ],
  "North East": [
    "Nalerigu",
    "Walewale",
    "Gambaga",
    "Bimbilla",
  ],
  "Oti": [
    "Dambai",
    "Jasikan",
    "Kadjebi",
    "Nkwanta",
    "Kete Krachi",
  ],
  "Western North": [
    "Sefwi Wiawso",
    "Bibiani",
    "Juaboso",
    "Enchi",
    "Dadieso",
  ],
};

// Get all regions
export const getAllRegions = () => Object.keys(ghanaLocations).sort();

// Get cities for a specific region
export const getCitiesForRegion = (region) => {
  if (!region || !ghanaLocations[region]) return [];
  return ghanaLocations[region];
};

// Search regions
export const searchRegions = (query) => {
  if (!query) return getAllRegions();
  const lowerQuery = query.toLowerCase();
  return getAllRegions().filter((region) =>
    region.toLowerCase().includes(lowerQuery)
  );
};

// Search cities within a region
export const searchCities = (region, query) => {
  const cities = getCitiesForRegion(region);
  if (!query) return cities;
  const lowerQuery = query.toLowerCase();
  return cities.filter((city) => city.toLowerCase().includes(lowerQuery));
};
